import * as React from 'react';
const EmorroidiIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M122.77 131.36c2.11-1.37 3.29-3.58 3.29-3.58 8.21 1.27 11.32-7.64 11.32-12.27s-3.35-9.03-3.35-9.03c3.7-5.21.23-10.76.23-10.76s3.12-4.17 3.12-7.87-2.08-7.29-2.08-7.29 2.76-4.17 2.08-8.33c-1.11-6.83-8.32-5.55-8.32-5.55-5.2-6.02-11.21-1.27-11.21-1.27-7.39-4.4-13.17 1.27-13.17 1.27-4.04-4.05-11.67 0-11.67 0-4.27-5.55-11.09-1.39-11.09-1.39s-3.12-2.78-7.16-2.78c-11.67 0-8.09 13.89-8.09 13.89-5.89 4.51-1.5 12.61-1.5 12.61s-2.66 0-2.66 4.86 3.01 8.22 3.01 8.22-3.01 4.4-3.01 9.03c0 5.9 5.43 11.11 11.09 11.11s9.71-3.59 9.71-8.33-5.55-8.33-5.55-8.33c3.81-7.52-1.27-12.38-1.27-12.38 4.28-3.47 0-10.41 0-10.41 3.37-1.31 4.04-6.36 4.04-6.36 3.93 3.01 10.4.58 10.4.58 5.13 4.84 10.4.81 10.4.81 4.27 4.63 10.98 1.16 10.98 1.16 3.7 2.89 11.21-1.16 11.21-1.16-1.6 2.95-1.81 5.4-1.44 7.3 0 0-3.17 5.9-.13 11.96-1.73 3.61-1.9 13.66-.66 16.15 1.04 2.09-3.31 3.47-3.31 3.47-4.18-3.07-8.23-.85-10.07.52"
      className="prefix__cls-2"
    />
    <path
      d="M73.62 122.22c2.04 1.53 1.75 3.5 1.74 5.3"
      className="prefix__cls-2"
    />
    <circle cx={100} cy={137.49} r={8.66} className="prefix__cls-1" />
    <circle cx={100} cy={137.49} r={1.24} className="prefix__cls-1" />
    <circle cx={100} cy={137.49} r={16.14} className="prefix__cls-1" />
  </svg>
);
export default EmorroidiIcon;
